import {ApiService} from './api.service';
import {Injectable} from '@angular/core';

export interface ActivityLog {
  created_date: string;
  user_display_name: string;
  description: string;
  user_reason_for_action?: string;
  category_text: string;
  severity_level_text: string;
  customer_display_name: string;
}

interface GetActivityLogResponse {
  activity_log_records: ActivityLog[];
}

@Injectable({
  providedIn: 'root'
})
export class ActivityLogApiService {

  constructor(
    private apiService: ApiService
  ) {}

  public async postActivityLogGridQuery(gridRequest): Promise<any> {
    return this.apiService.getResponseJson({
      urlPart: '/activity-log/grid-query',
      method: 'POST',
      data: gridRequest
    });
  }

  public async logApplyAllRequest(
    cidId: number, cidName: string, customerId: number): Promise<{}> {
    const data = {
      cid_id: cidId,
      cid_name: cidName,
      customer_id: customerId};
    return this.apiService.getResponseJson({
        urlPart: `/activity-log/log-apply-all-request`,
        method: 'POST',
        data
    });
  }  

  public async getCategoryOptions(gridPage: string): Promise<any> {
    return this.apiService.getResponseJson({
      urlPart: `/activity-log/get-category-options/${gridPage}`
    });
  }
}
